module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    staticClass: "adorn-bottom",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-2": "",
      "pt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 77,
      "imaSrc": "contenido/diapositiva_24",
      "imaAlt": "Calculadora para el presupuesto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Calculadora de patrimonio",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Calculadora"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("de")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" patrimonio")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeInDown dura_2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": "",
      "pt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Calculadora de patrimonio',
      "videoEmbed": "ADMINISTRACIONDINERO50CalculadoraDePatrimoniob.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('p', [_vm._v("\n        Esta herramienta le permitirá determinar cuál es su patrimonio.\n        Una vez finalice el curso, encontrará desbloqueada la calculadora\n        de "), _c('strong', [_vm._v("patrimonio")]), _vm._v(" de manera permanente en la sección "), _c('strong', [_vm._v("Mi perfil")]), _vm._v(" y\n        podrá usarla las veces que necesite. También podrá descargar\n        la información en formato PDF.\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c38d3b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-50.vue
// module id = 1022
// module chunks = 1